import { ListOfNavigation } from '@components/navigation';
import { linksData } from '@components/navigation/constants';
import theme from '@config/theme';
import { configs } from '@containers/information/configs';
import { isClientCareerMosaic } from '@global/helpers/general';
import { useIsDesktop } from '@global/hooks';
import { trackingEvents } from '@global/monitoring/mixpanel';
import { Info, PlayCircle } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Button, Drawer, IconButton, SxProps, useMediaQuery } from '@mui/material';
import { updateMiscStore } from '@redux/slices/misc';
import { RootState, store } from '@redux/store';
import { navigateTo } from '@services/navigation';
import mixpanel from 'mixpanel-browser';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import LayoutContext from '../context';
import Branding from './branding';
interface TopBarProps {
  showFAQ?: boolean;
  sx?: SxProps;
}

function TopBar({ showFAQ = false, sx = {} }: TopBarProps) {
  const smallerThanSMScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [openSidebar, setOpenSidebar] = useState(false);
  const auth: any = useSelector((s: RootState) => s.auth);
  const { accessToken } = auth;

  const { showContactUs } = useContext(LayoutContext);

  const isDesktop = useIsDesktop();
  const location = useLocation();

  useEffect(() => {
    setOpenSidebar(false);
  }, [location.pathname]);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenSidebar(newOpen);
  };
  return (
    <>
      <Box
        color="default"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'border.main',
          // maxHeight: '4vh',
          boxShadow: 'none',
          bgcolor: '#ffffff',
          p: '.85em 0',
          mb: '1rem',
          ...sx
        }}>
        <Box
          sx={{
            width: {
              xs: '100%',
              lg: accessToken ? '80%' : '100%',
              blg: accessToken ? '80%' : '100%'
            },
            margin: 'auto',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'space-between'
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {!isClientCareerMosaic() && !isDesktop && Boolean(accessToken) ? (
              <IconButton onClick={() => setOpenSidebar(true)} sx={{ margin: '.5rem 1rem' }}>
                <MenuIcon sx={{ height: '2.1rem', width: '2.1rem' }} />
              </IconButton>
            ) : null}
            <Branding />
          </Box>

          {isDesktop || showFAQ ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'flex-end', p: '.5rem 1rem', width: '50%' }}>
              {import.meta.env.VITE_DEMO_VIDEO_LINK && isDesktop && (
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => {
                    mixpanel.track(trackingEvents.misc.events.watchVideo);
                    store.dispatch(updateMiscStore({ openDemo: true }));
                  }}
                  sx={{
                    fontSize: '1.2rem',
                    width: 'fit-content',
                    p: '.75rem 1.25rem',
                    borderRadius: '.4em'
                  }}>
                  <PlayCircle /> &nbsp; Watch Demo
                </Button>
              )}
              {configs.faq && (
                <Button
                  onClick={() => {
                    mixpanel.track(trackingEvents.misc.events.faq);
                    navigateTo('/instructions');
                  }}
                  variant={accessToken ? 'outlined' : 'contained'}
                  color="primary"
                  sx={{
                    cursor: 'pointer',
                    color: accessToken ? 'primary.main' : 'white',
                    fontSize: { xs: '1.1rem', sm: '1.2rem' },
                    width: 'fit-content',
                    p: '.75rem 1.25rem',
                    borderRadius: '.4em',
                    fontFamily: accessToken ? 'inherit' : 'Nunito Sans, sans-serif',
                    fontWeight: '700',
                    boxShadow: 'none !important'
                  }}>
                  {accessToken && <Info sx={{ mr: '.5rem' }} />}
                  {smallerThanSMScreen ? 'FAQs' : 'Instructions / FAQs'}
                </Button>
              )}
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
      <Drawer open={openSidebar} onClose={toggleDrawer(false)}>
        <ListOfNavigation
          linksData={linksData}
          onClick={(text: string) => {
            setOpenSidebar(false);
            linksData[text].onClick();
          }}
          showContactUs={showContactUs}
        />
      </Drawer>{' '}
    </>
  );
}

export default TopBar;
